/* src/app/master-data/customer-item/customer-item-form/customer-item-form.component.css */
/*# sourceMappingURL=customer-item-form.component-BAKHUOQT.css.map */
